var intents = ['generic', 'activities', 'cash', 'day-use', 'deals', 'family', 'flights', 'homes', 'hotels', 'price', 'primary', 'trips', 'vip-bronze', 'vip-gold', 'vip-platinum', 'vip-prime', 'vip-silver', 'negative', 'notice', 'positive', 'urgent'];

export { intents };
//# sourceMappingURL=Theme.js.map
